// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30Qpo","content":"styles_content__2a8eA","row":"styles_row__CoBRO","footer":"styles_footer__27ngH","phraseLength":"styles_phraseLength__2Eo0n"};